export const GOOGLE_ANALYTICS_ID = "UA-213660775-1"